import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useAudio } from '../context/AudioManagementContext';
import Checkbox from './Checkbox';
import Modal from './Modal';
import Button from './Button';
import { useAuth } from '../context/AuthContext';

function RSVP({ show = false, onClose, onSubmit }) {
  const { playSubmit } = useAudio();
  const { status } = useAuth();
  const [loading, setLoading] = useState(!status);
  const [error, setError] = useState(undefined);

  const [email, setEmail] = useState(status?.email || '');
  const [attending, setAttending] = useState(status?.attending || {});
  const [message, setMessage] = useState(status?.message || '');

  useEffect(() => {
    if (status) {
      setLoading(false);
      setEmail(status.email || '');
      setAttending(status.attending || {});
      setMessage(status.message || '');
    }
  }, [status]);

  if (!show || !status) {
    return;
  }

  const updateAttending = (name, value) => {
    attending[name] = value;
    setAttending({ ...attending });
  };

  const onSubmitWrapper = (event) => {
    if (
      !attending ||
      Object.keys(attending).length < (status?.names?.length || 100)
    ) {
      setError('please indicate whether you can attend');
      return;
    }
    if (!email) {
      setError('please provide an email address');
      return;
    }
    if (event) {
      if (event.stopPropagation) event.stopPropagation();
      if (event.cancelable && !event.isDefaultPrevented())
        event.preventDefault();
    }

    setLoading(true);
    setError(undefined);
    playSubmit(0.03, () => {
      onSubmit({ email, attending, message }, () => setLoading(false));
    });
  };

  const attendingElements = status?.names?.map((name) => {
    return (
      <div className="form-section" key={name}>
        <label htmlFor={name}>{name?.toUpperCase()}:</label>
        <Checkbox
          checked={attending && attending[name]}
          toggle={(value) => {
            updateAttending(name, value);
          }}
        />
      </div>
    );
  });

  return (
    <Modal show={show} onClose={onClose} className="rsvp">
      <div className="modal-contents">
        <h1>{loading ? 'SUBMITTING...' : 'RSVP'}</h1>
        <p style={{ color: 'red' }}>{error}</p>
        <form onSubmit={onSubmitWrapper}>
          {attendingElements}
          <div className="form-section pixel-corners-wrapper">
            <input
              type="email"
              id="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              data-lpignore="true"
              placeholder="EMAIL ADDRESS"
              className="pixel-corners"
            />
          </div>
          <div className="form-section pixel-corners-wrapper">
            <textarea
              id="message"
              value={message}
              onChange={(e) => setMessage(e.target.value)}
              required
              data-lpignore="true"
              placeholder="MESSAGE"
              className="pixel-corners"
            />
          </div>
          <div className="form-section submit-button-wrapper">
            <Button
              type="submit"
              className="submit pixel-corners green"
              disabled={loading}
              onClick={onSubmitWrapper}
            >
              SUBMIT
            </Button>
          </div>
        </form>
      </div>
    </Modal>
  );
}

RSVP.propTypes = {
  show: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired
};

export default RSVP;
